import axios from 'axios'

const HOST = 'service.userjapa.me'

export default {
  namespaced: true,
  actions: {
    async verifyRoom (_, room_key) {
      try {
        const response = await axios.get(`https://${HOST}/api/room/${room_key}`)

        return response.data || {
          message: 'Failed to fetch data'
        }
      } catch (error) {
        return {
          message: error.message || 'Failed to verify room'
        }
      }
    }
  }
}
